export interface ISessionUser {
  user_id: string;
  email: string;
  pin: string;
  branch_id: string | null;
  region_id: string | null;
  zone_id: string | null;
  exp: number;
  sub: string;
  role: IUserRole;
}

export interface IUserRole {
  role_id: string;
  role_name: string;
  short_form: RoleShortForm;
}

export enum RoleShortForm {
  ZM = 'ZM',
  RM = 'RM',
  BM = 'BM',
  PM = 'PM',
  PO = 'PO',
  DM = 'DM',
  SMO = 'SMO',
  STO = 'STO',
  ADMIN = 'ADMIN',
  PMO = 'PMO',
  SO_MEAL = 'SOMEAL',
  MANAGER_MEAL = 'MMEAL',
  DM_MEAL = 'DMMEAL',
  MEAL = 'MEAL',
  STO_HS_CI = 'STO, HS-CI',
  STO_AG_SF = 'STO, AG-SF',
  STO_PL = 'STO, PL',
  DM_PL = 'DM, PL',
  DM_AG_SF = 'DM, AG-SF',
  DM_HSCI = 'DM, HSCI',
}
